const formsActionsTypes = {
    ADD_FORM:'ADD_FORM',
    DEL_FORM:'DEL_FORM',
    SET_FORMS:'SET_FORMS'
}

export default formsActionsTypes;